"use client";
import React from 'react';
import './FormInjures.css';
import { Button } from 'atm-global-stylish/dist';
const InjuredCard = ({injures, handleDeleteInjured,}) => {


	return (
        <>
            {injures.map((injured, index) => (
                <div key={injured.id}
                    className='flex flex-row w-full justify-between items-center border border-gray-300 p-3 rounded-md'>
                    <p className='text-black font-medium flex flex-row'>
                        {index + 1}. {injured.name}
                    </p>
                    <Button
                        handleClick={() => handleDeleteInjured(injured.uuid)}
                        type='secondary'
                        size='small'
                        className='p-2 md:p-3 border-[1px] border-red'
                        title='Eliminar'
                    />
                </div>
            ))}
        </>
	);
};

InjuredCard.propTypes = {};

export default InjuredCard;